import { gql } from '@apollo/client'

export const DATAROOM_FRAGMENT = gql`
  fragment DataroomFragment on Dataroom {
    id
    name
    user {
      id
      firstName
      lastName
    }
    company {
      id
      name
    }
    targetCompanies {
      id
      name
    }
    site {
      id
      name
    }
    isPublished
    updatedAt
    createdAt
  }
`

const SITE_FIELDS = gql`
  fragment DataroomSiteFields on PreQualifiedSite {
    id
    name
  }
`

const COMPANY_FIELDS = gql`
  fragment DataroomCompanyFields on Company {
    id
    name
  }
`

export const DATAROOM_BASE_QUERIES = gql`
  ${SITE_FIELDS}
  ${COMPANY_FIELDS}
  query DATAROOM_BASE_QUERIES($siteFilter: JSON!, $companyFilter: JSON!) {
    sites: findSitesAdmin(filter: $siteFilter) {
      ...DataroomSiteFields
    }
    companies: findCompanies(filter: $companyFilter) {
      ...DataroomCompanyFields
    }
  }
`
